import { CONFIG } from 'constants/index';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { AppService } from 'services';
import { GenerateDataTranslation } from 'utils/translation';

interface DelegationApprovalDialogDescriptions {
  titleDialog?: string;
  checkEmailDesc?: any;
  maxNumberUserText?: string;
  delegatedUsersDesc?: any;
  delegationDateTimePicker?: any;
  confirmText?: string;
}

export const useDelegationApprovalDialogDescs = () => {
  const { t } = useTranslation(['editProfile','checkEmail']);
  const delegationApprovalDialogTranslation = GenerateDataTranslation(
    "editProfile"
  );
  const checkEmailTranslation = GenerateDataTranslation('checkEmail');

  const { generalConfig } = useSelector((state: RootState) => state.configReducer) as any;
  const { verbiageConfig } = generalConfig;

  const [descriptions, setDescriptions] = useState<DelegationApprovalDialogDescriptions>({
    titleDialog: t("editProfile:delegationDialog.title"),
    checkEmailDesc: checkEmailTranslation || null,
    maxNumberUserText: t("editProfile:delegationDialog.maxNumberUserText"),
    delegatedUsersDesc: {
      delegatedUser: delegationApprovalDialogTranslation?.delegatedUser,
      remove: delegationApprovalDialogTranslation?.remove
    },
    delegationDateTimePicker: {
      endDate: delegationApprovalDialogTranslation?.endDate,
      startDate: delegationApprovalDialogTranslation?.startDate,
      checkDate: delegationApprovalDialogTranslation?.checkDate,
      checkTime: delegationApprovalDialogTranslation?.checkTime,
      invalidTime: delegationApprovalDialogTranslation?.invalidTime
    },
    confirmText: t("editProfile:delegationDialog.confirmText")
  });

  useEffect(() => {
    (async () => {
      if (!verbiageConfig) return;
      await Promise.all([
        AppService.getValueConfigAzure(
          CONFIG.DELEGATION_APPROVAL_DIALOG_DESCRIPTION.KEY,
          CONFIG.DELEGATION_APPROVAL_DIALOG_DESCRIPTION.LABEL,
        )
      ]).then((data: any) => {
        let newDes = data[0] || {};
        setDescriptions(descriptions => ({
          ...descriptions,
          ...newDes,
        }));
      })
    })();
  }, [verbiageConfig]);

  return descriptions;
};
